import MuiCheckbox, { type CheckboxProps } from "@mui/material/Checkbox";

export type { CheckboxProps };

export function Checkbox(props: CheckboxProps) {
  return <MuiCheckbox {...props} />;
}
